import { Grid } from "@mui/material";
import { format, isValid } from "date-fns";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import BasicDialog from "../../../common/components/functional/dialogs/BasicDialog";
import LoadingSpinner from "../../../common/components/functional/loadingSpinner/LoadingSpinner";
import { VariationSelection } from "../../../common/types/apiTypes";
import { fetchTESVariations } from "../orderAPI";
import { VariationElement, VariationMap } from "../types/tesVariationTypes";
import { CloseAction, TesVariationForm } from "./TESVariationForm";

type Props = {
  tesId: string;
  date: Date | null;
  open: boolean;
  variationDefaults: VariationSelection[];
  onClose: (action?: CloseAction) => void;
  setTesVariation: (variation: VariationSelection[]) => void;
  isReadOnly?: boolean;
};

//TODO: rename redundant names
//TODO: This has nothing to do with order. move it to its own folder
export const OrderTesVariation = ({
  tesId,
  date,
  open,
  onClose,
  variationDefaults,
  setTesVariation,
  isReadOnly = false,
}: Props) => {
  const [elements, setElements] = useState<VariationElement[]>([]);
  const [defaults, setDefaults] = useState(variationDefaults);
  const [tesVariationsLoading, setTesVariationsLoading] = useState(false);

  const { t } = useTranslation("order");

  const updateVariation = (variation: VariationMap) => {
    const list = Array.from(variation);
    setTesVariation(list);
  };

  useEffect(() => {
    // first shift start date here
    if (tesId && date && isValid(date) && date.getFullYear() > 2000) {
      const startDate = format(date, "yyyy-MM-dd");
      setTesVariationsLoading(true);
      fetchTESVariations(tesId, startDate)
        .then((res) => {
          setElements(res.elements);

          // TODO: is this needed?
          // modal is not open and we need default values
          if (!open) {
            // defaults are applicable only for the first tes
            if (defaults.length > 0) setDefaults([]);
          }
        })
        .finally(() => {
          setTesVariationsLoading(false);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tesId, date]);

  // return defaults when tesId changes and modal is not open

  const form = (
    <Grid container rowSpacing={2} columnSpacing={1}>
      {tesVariationsLoading && <LoadingSpinner sx={{ marginTop: "8px" }} />}
      <TesVariationForm
        defaultValues={variationDefaults}
        updateVariation={updateVariation}
        elements={elements}
        onClose={onClose}
        disabled={isReadOnly}
        isLoading={tesVariationsLoading}
      />
    </Grid>
  );

  return (
    <BasicDialog
      open={open}
      hideActions
      title={t("setTes")}
      noBorder
      PaperProps={{ sx: { width: "550px", borderRadius: "12px" } }}
      content={form}
    />
  );
};
